import { RegionRepository } from '../repositories/RegionRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import { serviceLocator } from '@/utils/providers/serviceLocator'

export async function getMiniRegionCase(id: number) {
  const newRepository = serviceLocator.getService<RegionRepository>('RegionService')

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getMiniRegion(id),
    key: 'region',
    filterData: JSON.stringify(id)
  })
  if (data.value.error) return
  return data.value
}
